var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-form"},[_c('div',{staticClass:"c-form-content"},[_vm._t("default")],2),(_vm.$slots.button)?_c('div',{staticClass:"flex-center c-form-button"},[_vm._t("button")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }